let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gMvtj")).then(() => parcelRequire('k5Wqo'));